export enum RuntimeMode {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
}

export type EnvironmentName = 'dev' | 'stage' | 'local' | 'localhost' | 'prod' | 'default';

export interface IEnvironment {
  readonly name: EnvironmentName;
  readonly runtime: RuntimeMode;
  readonly amilearnDashboardUrl: string;
  readonly includeGTMTag: boolean;
  readonly gtmId: string;
  readonly apiBaseUrl: string;
  readonly sentryDsn: string;
  readonly subscriptionPaymentLink: string;
}

export interface IOAuthConfig {
  readonly domain: string;
  readonly redirectURI: string;
  readonly logoutURI: string;
  readonly grantType: string;
  readonly identityProvider: string;
}

export interface IFederatedSignInConfig {
  readonly provider: string;
  readonly expiresIn: number;
};

export interface IAWSConfig {
  readonly aws_project_region: string;
  readonly aws_content_delivery_bucket: string;
  readonly aws_content_delivery_bucket_region: string;
  readonly aws_content_delivery_url: string,
  readonly oauth: object;
  readonly Auth: IAmplifyAuth;
}

interface IAmplifyAuth {
  readonly identityPoolId: string;
  readonly region: string;
  readonly identityPoolRegion: string;
  readonly userPoolId: string;
  readonly userPoolWebClientId: string;
  readonly mandatorySignIn: boolean;
  readonly oauth: object;
  refreshHandlers: object;
}